import {
  Box,
  Button,
  Flex,
  IconButton,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
  useDisclosure,
  useToast
} from "@chakra-ui/react";
import { FaBell } from "react-icons/fa";
import React, { useState } from "react";
import { formatDateToSegments, showErrorToast } from "../../utils";
import { useGetNotifications, useUpdateNotificationStatus } from "../../hooks/query";
import { useNavigate } from "react-router-dom";
import { routes } from "../../config";
import { useTranslation } from "react-i18next";
import { hideAppSpinner, showAppSpinner } from "../../context/Store/slices/appSpinnerSlice";
import { useDispatch } from "react-redux";

export const NotificationModel = () => {

  const NOTIFICATION_PER_PAGE = 5;

  const toast = useToast();
  const navigate = useNavigate();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const dispatch = useDispatch();
  const { t } = useTranslation("translation", {
    keyPrefix: "actionNotifications.model"
  });

  const [notifications, setNotifications] = useState([]);

  const handleViewAll = () => {
    navigate(`${routes.notification}`);
    onClose();
  };

  useGetNotifications(
    `page=0&size=${NOTIFICATION_PER_PAGE}`,
    {
      onSuccess: (data) => {
        setNotifications(data?.content);
      },
      cacheTime: 0
    });

  const getRequestConfig = () => {
    return {
      onMutate: () => dispatch(showAppSpinner()),
      onError: err => showErrorToast(toast, err.response?.data?.parameters?.message ?? err.message),
      onSettled: () => dispatch(hideAppSpinner())
    };
  };

  const { mutate: updateNotificationStatus } = useUpdateNotificationStatus(getRequestConfig());

  // update the notification status to read once user opens the notification menu
  const handleMenuOpen = () => {
    onOpen();
    const notificationIds = notifications?.map(notification => notification.id);
    if (notificationIds?.length > 0) {
      updateNotificationStatus(notificationIds);
    }
  };

  return (
    <Box position="relative" display="inline-block">
      <Menu isOpen={isOpen} onOpen={handleMenuOpen} onClose={onClose}>
        <MenuButton as={IconButton} icon={<FaBell />} aria-label="Notifications" variant="ghost" />
        {notifications.some(notification => notification?.status === "UNREAD") && (
          <Box
            position="absolute"
            top="20%"
            right="20%"
            transform="translate(50%, -50%)"
            width="8px"
            height="8px"
            backgroundColor="red.500"
            borderRadius="full"
          />
        )}
        <MenuList minWidth="300px" maxWidth="400px" boxShadow="lg">
          {notifications?.length > 0 ? (
            notifications.map((notification) => (
              <MenuItem key={notification?.id} display="flex" flexDirection="column" alignItems="start"
                        backgroundColor={notification?.status === "READ" ? "white" : "gray.100"}>
                <>
                  <Text>{notification?.message}</Text>
                  <Text fontSize="xs" color="gray.500">
                    {formatDateToSegments(notification?.createdDate)}
                  </Text>
                </>
              </MenuItem>
            ))
          ) : (
            <MenuItem>{t("noNotifications")}</MenuItem>
          )}

          <Flex justifyContent="space-between" p="2" mt="2" borderTop="1px solid" borderColor="gray.200">
            <Button size="sm" onClick={handleViewAll} aria-label="View All">
              {t("viewAll")}
            </Button>
          </Flex>
        </MenuList>
      </Menu>
    </Box>
  );
};